module.exports = __webpack_public_path__ + "img/basket-transparent.db4dee5.svg";